"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.xml = exports.escapeXML = void 0;
const escapeXML = (unsafe) => {
    return unsafe.replace(/[<>&'"]/g, (c) => {
        switch (c) {
            case '<':
                return '&lt;';
            case '>':
                return '&gt;';
            case '&':
                return '&amp;';
            case "'":
                return '&apos;';
            case '"':
                return '&quot;';
            default:
                return '';
        }
    });
};
exports.escapeXML = escapeXML;
const xml = (strs, ...interpolations) => {
    const newStrs = [strs[0]];
    for (let i = 0; i < interpolations.length; i++) {
        const inter = interpolations[i];
        if (Array.isArray(inter)) {
            if (!inter[1]) {
                newStrs.push(String(inter[0]));
            }
            else {
                newStrs.push((0, exports.escapeXML)(String(inter[0])));
            }
        }
        else {
            newStrs.push((0, exports.escapeXML)(String(inter)));
        }
        newStrs.push(strs[i + 1]);
    }
    return newStrs.join('');
};
exports.xml = xml;
//# sourceMappingURL=formats.js.map